import { ApiError } from '@/shared/api'
import { Button } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { toast } from '@/shared/ui/toast'
import { useSetVisibility } from '../api/visibility'

interface VisibilityButtonProps {
  documentId: string
  visible: boolean
}

export function VisibilityButton({ documentId, visible }: VisibilityButtonProps) {
  const mutate = useSetVisibility(documentId)
  return (
    <Button
      variant="ghost"
      size="sm"
      disabled={mutate.isPending}
      onClick={() =>
        mutate.mutate(!visible, {
          onSuccess: () => toast.success(visible ? 'Скрыто от заказчика' : 'Открыто заказчику'),
          onError: (e) =>
            toast.error(
              e instanceof ApiError && e.isConflict
                ? 'Документ заказчика всегда виден'
                : 'Не удалось изменить видимость',
            ),
        })
      }
    >
      <Icon name={visible ? 'eye' : 'eye'} size={16} />
      {visible ? 'Скрыть от заказчика' : 'Показать заказчику'}
    </Button>
  )
}
